// ----------------------------------------------------------------------

export const setURLParams = (params) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            // Handle array values by appending multiple key-value pairs
            value.forEach((item) => {
                if (item !== null && item !== undefined) {
                    searchParams.append(key, String(item));
                }
            });
        } else if (value !== null && value !== undefined && value !== "" && value !== "all") {
            // Handle regular values
            searchParams.append(key, String(value));
        }
    });

    const paramsString = searchParams.toString();
    return paramsString ? `?${paramsString}` : "";
};

export function getURLQueryByName(key) {
    const query = urlQuery();

    return !query ? "" : ( query[key] || "" );
}

export function getQueryByName(url, key) {
    if (!url || !key) return undefined;

    const query = Object.fromEntries(
        ( url ? url.split("?")[1] : null )
            .split("&")
            .map((param) => param.split("=").map(decodeURIComponent))
    );

    return query[key] || undefined;
}

export function saveParamToCookies() {
    const params = new URLSearchParams(window.location.search);

    params.forEach((value, key) => {
        document.cookie = `${key}=${encodeURIComponent(value)}; path=/; max-age=${60 * 60 * 24 * 2}`; // 2 days
    });
}

// ----------------------------------------------------------------------

function urlQuery() {
    const query0 = getSearchQuery();
    const query1 = getSearchParam();

    if (!query0 || !query1) return undefined;

    return { ...query0, ...query1 };
}

function getSearchQuery() {
    const { search } = window.location;

    if (!search) return undefined;

    return Object.fromEntries(
        search
            .slice(1) // 去除 '?'
            .split("&")
            .map((param) => param.split("=").map(decodeURIComponent))
    );
}

function getSearchParam() {
    const params = new URLSearchParams(window.location.search);

    return params.toString() ? Object.fromEntries(params) : undefined;
}
